import SpeechRecognitionMic from "@/app/components/core/SpeechRecognitionMic";
import ModalInformation from "@/app/components/ui/Modals/Information";
import VoiceAssistant from "@assets/images/vetic_assistant.png";
export const SpeechRecognitionModal = () => {
  return (
    <ModalInformation
      modalId="SPEECH_RECOGNITION_MODAL"
      title={
        <div className="flex justify-start items-end gap-x-2">
          <img className="w-10 h-10" src={VoiceAssistant} alt="Voice Assistant" />
          <h1 className="bg-gradient-to-r font-semibold from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text">
            Vetic Voice Assistant
          </h1>
        </div>
      }
    >
      <SpeechRecognitionMic />
    </ModalInformation>
  );
};

export default SpeechRecognitionModal;
